import { IModule, IModuleBuilder } from "app/IModule";
import NotificationsReducer from "./notifications.reducer";
import React from "react";

export default class NotificationsModule implements IModule {

    build(builder: IModuleBuilder) {
        builder.addReducer("notifications", new NotificationsReducer());
        builder.addRoute("/notifications", React.lazy(() => import("./Notifications.page")));
    }
}